import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@material-ui/core";

const NotFound = () => {
    return (
        <div className="not-found">
            <div className="not-found--wrapper">
                <h1>not 404 found</h1>

                <Link to="/">
                    <Button color="inherit">Return Home</Button>
                </Link>
            </div>
        </div>
    );
};

export default NotFound;
